import { render } from "./DatosPersonales.vue?vue&type=template&id=8e7a7c3e&scoped=true"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"

import "./DatosPersonales.vue?vue&type=style&index=0&id=8e7a7c3e&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7a7c3e"]])

export default __exports__